import React, { useEffect, useState } from 'react'

import { useNavigate } from 'react-router-dom'
import { useStore } from 'react-context-hook'

import moment from 'moment'


// Services
import FormService from '../services/FormService'
import LocalStorageService from '../services/LocalStorageService'
import OrganisationService from '../services/OrganisationService'


// Grommet
import { DocumentPdf, DocumentText, Folder, Image, Video } from 'grommet-icons'

// Appt Components
import Anchor from '../components/simple/anchor/Anchor'
import Box from '../components/simple/box/Box'
import DateInput from '../components/simple/input/DateInput'
import FontAwesome from '../components/compound/fontAwesome/FontAwesome'
import FormField from '../components/simple/formField/FormField.js'
import Text from '../components/simple/text/Text'
import H1 from '../components/simple/heading/H1'
// import Button from '../components/simple/button/Button'




import BreadcrumbBar from './shared/BreadcrumbBar'

// Appt Widgets
import CounterBox from '../components/compound/counterBox/CounterBox'
import ListBox from '../components/compound/listBox/ListBox'
import { Form } from 'grommet'
import AdminService from '../services/AdminService.js'
import NotificationService from '../services/NotificationService.js'

function Dashboard (props) {
  const navigate = useNavigate()

  const [apiToken, setApiToken, deleteApiToken] = useStore()
  const [activeOrg, setActiveOrg, deleteActiveOrg] = useStore()

  const [dashboardState, setDashboardState] = useState({
    services: '',
    users: '',
    students: '',
    smartplans: '',
    incidents: ''
  })

  const [services, setServices] = useState()
  const [systemUsers, setSystemUsers] = useState()

  // NOTE: getUser and clearSession currently need to be called on every screen
  // this is definitely a violation of DRY and needs to be refactor

  // check if the user is logged in, if so restored the session
  // const getUser = () => {
  //   // check local storage
  //   var apiToken = LocalStorageService.get('apiToken')
  //   if (apiToken) {
  //     setApiToken(apiToken)
  //     // get currentOrgs
  //     const myOrganisations = LocalStorageService.get('currentOrgs')
  //     setCurrentOrgs(myOrganisations)
  //   } else {
  //     clearSession()
  //   }
  // }

  // // clear the user's session if they log out
  // const clearSession = () => {
  //   // remove all localstorage
  //   LocalStorageService.clear()

  //   // remove the session data
  //   deleteApiToken()
  //   deleteCurrentUser()
  //   deleteCurrentOrgs()
  //   navigate('/')
  // }

  const contentIcons = {
    pdf: <DocumentPdf size='medium' color='brand' />,
    text: <DocumentText size='medium' color='brand' />,
    category: <Folder size='medium' color='brand' />,
    image: <Image size='medium' color='brand' />,
    video: <Video size='medium' color='brand' />
  }

  const [searchDates, setSearchDates] = useState({
    searchFrom: '',
    searchTo: ''
  })

  // // Quick Stats date has been entered
  // const onDateChange = (searchDate, field) => {
  //   // console.log(moment(value).format('YYYY-MM-DD'))
  //   // const x = moment(searchDate, 'YYYY-MM-DD')
  //   // console.log(x.format())
  //   setSearchDates(previousValues => ({
  //     ...previousValues,
  //     fromDate: field === 'from' ? searchDate.value : previousValues.fromDate,
  //     toDate: field === 'to' ? searchDate.value : previousValues.toDate
  //   }))
  // }

  // const dateValidation = [
  //   date => {
  //     console.log(date)
  //     // const expireDate = date.split('/').reverse()
  //     // expireDate.splice(0, 0, '20')
  //     // const newYear = expireDate[0] + expireDate[1]
  //     // expireDate.splice(0, 2, newYear)
  //     // const expires = new Date(expireDate)
  //     // if (
  //     //   expires.getMonth() < currentDate.getMonth() &&
  //     //   expires.getFullYear() <= currentDate.getFullYear()
  //     // ) {
  //     //   return { message: 'invalid date', status: 'error' }
  //     // }
  //     // return undefined
  //     if (searchDates.searchFrom && searchDates.searchTo) {
  //       const fromMoment = moment(searchDates.searchFrom)
  //       const toMoment = moment(searchDates.searchTo)
  //       // if (moment(searchDates.searchTo).isBefore(searchDates.searchFrom)) {
  //       if (toMoment.isBefore(fromMoment, 'day')) {
  //         return { message: 'both dates need to be entered', status: 'error' }
  //       }
  //     }

  //     // if (!searchDates.fromDate || !searchDates.toDate) {
  //     //   return { message: 'both dates need to be entered', status: 'error' }
  //     // }
  //   }
  // ]

  useEffect(() => {
    // console.log(searchDates)
    if (searchDates.searchFrom && searchDates.searchTo) {
      const fromMoment = moment(searchDates.searchFrom)
      const toMoment = moment(searchDates.searchTo)
      // if (moment(searchDates.searchTo).isBefore(searchDates.searchFrom)) {
      if (toMoment.isBefore(fromMoment, 'day')) {
        // do nothing
      } else {
        getDashboardCounts(true)
      }
    }
  }, [searchDates])

  // Get number of Users for this Organisation
  const getDashboardCounts = async (dateRestricted) => {

    if (!activeOrg || !activeOrg.id || !apiToken) {
      // Temporary use of apiToken
      // const apiToken = LocalStorageService.get('apiToken')
      //
      const apiToken = LocalStorageService.get('apiToken')
      const activeOrg = LocalStorageService.get('activeOrg')
      const organisationId = activeOrg.id

      const dateRestrictedQuery = {
        createdAt: [
          {
            operator: '>',
            value: moment(searchDates.searchFrom).format('YYYY-MM-DD HH:mm:ss')
          },
          {
            operator: '<',
            value: moment(searchDates.searchTo).format('YYYY-MM-DD HH:mm:ss')
          }
        ]
      }

      let params = {
        fields: 'id,name,createdAt',
        sort: 'createdAt DESC'
      }

      if (dateRestricted) {
        params.where = dateRestrictedQuery
      }

      const dashboardCount = {}

      const organisations = await OrganisationService.getOrganisations(apiToken, params, organisationId)

      setServices(organisations.data)

      dashboardCount.services = organisations?.page?.total || 0

      params = {
        fields: 'id,email,firstName,lastName,type',
        orgId: activeOrg.id
      }

      if (dateRestricted) {
        params.where = dateRestrictedQuery
      }

      const globalAdmins = await AdminService.getGlobalAdmins(apiToken)
      setSystemUsers(globalAdmins)

      params = {
        fields: 'id,user,organisation,reference,type',
        limit: 1000,
        orgId: activeOrg.id
      }

      const where = {
        organisationId: organisationId,
        type: 'incidentreport',
        status: 'Published'
      }

      if (dateRestricted) {
        Object.assign(where, dateRestrictedQuery)
      }

      // get incident reports
      const incidentReportSubmissions = await FormService.getSubmissions(apiToken, params, where)

      dashboardCount.incidents = 0
      if (incidentReportSubmissions?.page?.total) {
        dashboardCount.incidents = incidentReportSubmissions.page.total
      }

      where.type = 'behaviourplan'

      // get incident reports
      const smartPlanSubmissions = await FormService.getSubmissions(apiToken, params, where)

      dashboardCount.smartplans = 0
      if (smartPlanSubmissions?.page?.total) {
        dashboardCount.smartplans = smartPlanSubmissions.page.total
      }

      setDashboardState(dashboardCount)
    }
  }

  const doWondeSync = async () => {
    try {
      AdminService.doWondeSync()
      NotificationService.info('Wonde data synced requested. Please check back later.')
    } catch (error) {
      NotificationService.error('Error syncing Wonde data')
    }
  }

  // Basically componentDidMount
  useEffect(() => {
    getDashboardCounts(false)
  }, [])

  useEffect(() => {
    getDashboardCounts(false)
  }, [props.activeOrg])

  return (
    <Box width='xlarge'>
      <BreadcrumbBar
        path={<><Anchor href='/'>BehaviourSmart</Anchor><Text color='brand' size='xsmall'>{location.pathname}</Text></>}
      >
        <H1 margin={{ top: 'small', bottom: 'none' }}>Dashboard </H1>
      </BreadcrumbBar>
      {/* <Box background='white' direction='column' flex='grow' gap='small' margin={{ bottom: 'medium' }} round='small'>
        <Box direction='column' pad={{ horizontal: 'medium' }}>
          <H1 margin={{ top: 'small', bottom: 'none' }}>Dashboard </H1>
          {error &&
            <FlashMessage message={error} />}
          <Text margin={{ bottom: 'small', top: 'xsmall' }} size='xsmall'><Anchor href='/'>BehaviourSmart</Anchor><Text color='brand' size='xsmall'>{location.pathname}</Text></Text>
        </Box>
      </Box> */}

      <Box background='white' direction='column' gap='small' margin={{ bottom: 'medium' }} round='small' flex='grow'>
        <Box direction='row-responsive' justify='between' pad={{ horizontal: 'medium', vertical: 'small' }}>
          <Box>{/* pad={{ bottom: responsive === 'small' ? 'medium' : 'none' }} */}
            <Text size='xxlarge' weight={400} margin={{ top: 'none' }}>Quick Stats</Text>
          </Box>
          {/* <Box direction='row' gap='medium'> */}
          <Form
            // messages={{
            //   required: 'This is a required field.',
            // }}
            onChange={setSearchDates}
            // onValidate={validationResults => {
            //   console.log('validationResults = ', validationResults)
            //   setValid(validationResults.valid)
            // }}
            value={searchDates}
            // validate='blur'
          >
            <Box direction='row' gap='medium'>
              <FormField
                htmlFor='searchFrom'
                label='From'
                name='searchFrom'
                // validate={dateValidation}
              >
                <DateInput
                  format='dd/mm/yyyy'
                  name='searchFrom'
                  // onChange={(value) => { onDateChange(value, 'from') }}
                  // value={searchDates.fromDate}
                />
              </FormField>

              <FormField
                htmlFor='searchTo'
                label='To'
                name='searchTo'
                // validate={dateValidation}
              >
                <DateInput
                  format='dd/mm/yyyy'
                  name='searchTo'
                  // onChange={(value) => { onDateChange(value, 'to') }}
                  // value={searchDates.toDate}
                />
              </FormField>
            </Box>
          </Form>
          {/* </Box> */}
        </Box>
      </Box>

      <Box direction='row-responsive' gap='medium' flex={1}>
        <Box gap='small' justify='flex-start' margin={{ bottom: 'medium' }}>
          {/* <ListBox
            data={[
              {
                name: 'Wonde Sync',
                action: () => {
                 doWondeSync()
                }
              }
            ]}
            heading='Admin Actions'
          >
             {d => (
              <Box>
              <Button onClick={() => { d.action() }} plain>
                <Box direction='row' justify='between'>
                    <Text>{d.name}</Text>
                    <FontAwesome color='brand' icon={['fas', 'angle-right']} />
                </Box>
                </Button>
              </Box>
            )}
          </ListBox> */}
          <CounterBox counter={dashboardState.services} iconColor='#52bc94' icon='briefcase'>Services</CounterBox>
        </Box>

        <Box direction='row-responsive' gap='medium' width='medium' flex={1}>
          <ListBox
            data={services?.slice(0, 15)}
            heading='Recent Services'
          >
            {datum => (
              <Box>
                <Anchor href={`/service/${datum.id}/edit`} label={<Box direction='row' justify='between'><Text>{datum.name}</Text><FontAwesome color='brand' icon={['fas', 'angle-right']} /></Box>} />
              </Box>
            )}
          </ListBox>
        </Box>
        <Box direction='row-responsive' gap='medium' flex={1}>
          <ListBox
            data={systemUsers?.slice(0, 5)}
            heading='Global Admin Users'
          >
            {datum => (
              <Box>
                <Text>{datum.firstName || ''}&nbsp;{datum.lastName || ''}</Text>
              </Box>
            )}
          </ListBox>
        </Box>
      </Box>
    </Box>
  )
}

export default Dashboard
